<app-payu-card-number-widget
  (tokenizeSuccessEvent)="handleTokenizeSuccessEvent($event)"
  [withPrivacyPolicy]="withPrivacyPolicy()" />

<div
  [class.justify-center]="withCenteredButton()"
  [class.justify-end]="!withCenteredButton()"
  class="mt-4 flex">
  <p-button
    (onClick)="handleSubmitClick()"
    appPrimengButton
    label="Zapłać i zapisz kartę" />
</div>
